module.exports = require("mdi-material-ui/CameraOff");